import { createElement, PureComponent } from 'react';
import Base from './Base';

export default class Close extends PureComponent {

    public render() {
        return createElement(
            Base,
            {...this.props, base: 36, className: '-stroked'},
            <>
                <path d="M9 27L27 9M27 27L9 9"/>
            </>,
        );
    }
}
